import { useCallback, useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Dialogs from "components/ui/dialogs/dialogs";

export const useStudyManagementHandlers = (props) => {
  const context = useContext(AppContext);

  const handleSave = useCallback(() => {
    // Déclencher le clic sur le bouton de sauvegarde du header
    const saveIcon = document.querySelector("#saveModal");
    if (saveIcon) {
      // Chercher le bouton parent
      const saveButton = saveIcon.closest("button");
      if (saveButton) {
        saveButton.click();
      } else {
        // Si pas de bouton parent, créer un événement de clic sur l'icône
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        saveIcon.dispatchEvent(clickEvent);
      }
    } else {
      // Fallback: utiliser l'ancien système
      window.top.postMessage({ Action: "save" }, "*");
    }
  }, []);

  const handleGoToAudits = useCallback(() => {
    if (context.state.TypeSimulation !== "" && context.state.AdminAccess !== true) {
      Dialogs.confirm(
        "Vous avez effectué des modifications non sauvegardées, souhaitez-vous les enregistrer pour ne pas les perdre ?",
        "Gestionnaire de données",
        () => {
          if (context.state.IdDossier === "") {
            context.handleSaveAsDossier(context.state.TypeSimulation);
          } else {
            context.handleSaveDossier();
          }
          context.handleValueChange("TypeSimulation", "");
          if (props?.SetAccessEtude) {
            props.SetAccessEtude("");
          }
          context.handleValueChange("AdminAccess", false);
        },
        () => {
          context.handleValueChange("TypeSimulation", "");
          if (props?.SetAccessEtude) {
            props.SetAccessEtude("");
          }
          context.handleValueChange("AdminAccess", false);
        }
      );
    } else {
      context.handleValueChange("TypeSimulation", "");
      if (props?.SetAccessEtude) {
        props.SetAccessEtude("");
      }
      context.handleValueChange("AdminAccess", false);
    }
  }, [context, props]);

  const handleGoToExtranet = useCallback(() => {
    if (context.state.TypeSimulation !== "" && context.state.AdminAccess !== true) {
      Dialogs.confirm(
        "Vous avez effectué des modifications non sauvegardées, souhaitez-vous les enregistrer pour ne pas les perdre ?",
        "Gestionnaire de données",
        () => {
          if (context.state.IdDossier === "") {
            context.handleSaveAsDossier(context.state.TypeSimulation);
          } else {
            context.handleSaveDossier();
          }
          context.handleValueChange("AccesSimulateur", false);
          context.handleValueChange("TypeSimulation", "");
          if (props?.SetAccessEtude) {
            props.SetAccessEtude("");
          }
          context.handleValueChange("AdminAccess", false);
        },
        () => {
          context.handleValueChange("AccesSimulateur", false);
          context.handleValueChange("TypeSimulation", "");
          if (props?.SetAccessEtude) {
            props.SetAccessEtude("");
          }
          context.handleValueChange("AdminAccess", false);
        }
      );
    } else {
      context.handleValueChange("AccesSimulateur", false);
      context.handleValueChange("TypeSimulation", "");
      if (props?.SetAccessEtude) {
        props.SetAccessEtude("");
      }
      context.handleValueChange("AdminAccess", false);
    }
  }, [context, props]);

  return {
    handleSave,
    handleGoToAudits,
    handleGoToExtranet
  };
};
